export default __webpack_public_path__ + "static/media/outline_light_middile.f26efdbe.png";